import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
const names = ['María', 'Carolina', 'Lucía', 'Valentina', 'Camila', 'Florencia', 'Romina', 'Daniela', 'Gabriela', 'Andrea', 'Silvia', 'Patricia', 'Claudia', 'Marta', 'Laura', 'Carlos', 'Martín', 'Jorge', 'Roberto', 'Diego'];
const locations = ['CDMX', 'Monterrey', 'Guadalajara', 'Puebla', 'Tijuana', 'León', 'Ciudad Juárez', 'Zapopan', 'Mérida', 'San Luis Potosí', 'Aguascalientes', 'Hermosillo', 'Saltillo', 'Mexicali', 'Culiacán', 'Querétaro', 'Morelia', 'Chihuahua'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [person, setPerson] = useState({
    name: '',
    location: ''
  });
  useEffect(() => {
    const showToast = () => {
      setPerson({
        name: getRandomItem(names),
        location: getRandomItem(locations)
      });
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    // First toast after 12 seconds
    const initialTimeout = setTimeout(showToast, 12000);
    // Then every 25-40 seconds
    const interval = setInterval(() => {
      showToast();
    }, 25000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-191">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 0
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 max-w-xs" data-id="element-192">
          <div className="bg-white rounded-xl shadow-2xl border border-gold/20 p-4 flex items-center gap-3" data-id="element-193">
            <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0" data-id="element-194">
              <ShieldCheck className="w-5 h-5 text-gold" data-id="element-195" />
            </div>
            <div data-id="element-196">
              <p className="font-body text-sm text-navy-dark leading-snug" data-id="element-197">
                <strong className="text-navy-dark" data-id="element-198">{person.name}</strong> de{' '}
                <strong data-id="element-199">{person.location}</strong>
              </p>
              <p className="font-body text-xs text-navy/60 mt-0.5" data-id="element-200">
                acaba de acceder a la oración
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}